const detailedBusinessSectors = {
  DBS_A: ['DBS_A_1', 'DBS_A_2', 'DBS_A_3', 'DBS_A_4'],
  DBS_B: [
    'DBS_B_1',
    'DBS_B_2',
    'DBS_B_3',
    'DBS_B_4',
    'DBS_B_5',
    'DBS_B_6',
    'DBS_B_7',
    'DBS_B_8',
    'DBS_B_9',
    'DBS_B_10',
    'DBS_B_11'
  ],
  DBS_C: ['DBS_C_1', 'DBS_C_2', 'DBS_C_3', 'DBS_C_4', 'DBS_C_5'],
  DBS_D: [
    'DBS_D',
    'DBS_D_1',
    'DBS_D_2',
    'DBS_D_3',
    'DBS_D_4',
    'DBS_D_5',
    'DBS_D_6',
    'DBS_D_7',
    'DBS_D_8',
    'DBS_D_9',
    'DBS_D_10',
    'DBS_D_11',
    'DBS_D_12',
    'DBS_D_13'
  ],
  DBS_E: ['DBS_E_1', 'DBS_E_2'],
  DBS_F: ['DBS_F_1', 'DBS_F_2', 'DBS_F_3', 'DBS_F_4', 'DBS_F_5'],
  DBS_G: ['DBS_G_1', 'DBS_G_2', 'DBS_G_3', 'DBS_G_4', 'DBS_G_5'],
  DBS_H: ['DBS_H_1', 'DBS_H_2', 'DBS_H_3', 'DBS_H_4', 'DBS_H_5'],
  DBS_I: [
    'DBS_I_1',
    'DBS_I_2',
    'DBS_I_3',
    'DBS_I_4',
    'DBS_I_5',
    'DBS_I_6',
    'DBS_I_7',
    'DBS_I_8'
  ],
  DBS_J: ['DBS_J_1', 'DBS_J_2', 'DBS_J_3', 'DBS_J_4', 'DBS_J_5'],
  DBS_K: ['DBS_K_1', 'DBS_K_2', 'DBS_K_3', 'DBS_K_4', 'DBS_K_5', 'DBS_K_6'],
  DBS_L: [
    'DBS_L_1',
    'DBS_L_2',
    'DBS_L_3',
    'DBS_L_4',
    'DBS_L_5',
    'DBS_L_6',
    'DBS_L_7',
    'DBS_L_8'
  ],
  DBS_M: [
    'DBS_M_1',
    'DBS_M_2',
    'DBS_M_3',
    'DBS_M_4',
    'DBS_M_5',
    'DBS_M_6',
    'DBS_M_7'
  ],
  DBS_N: ['DBS_N_1', 'DBS_N_2', 'DBS_N_3', 'DBS_N_4', 'DBS_N_5', 'DBS_N_6'],
  DBS_O: ['DBS_O_1', 'DBS_O_2'],
  DBS_P: [
    'DBS_P_1',
    'DBS_P_2',
    'DBS_P_3',
    'DBS_P_4',
    'DBS_P_5',
    'DBS_P_6',
    'DBS_P_7'
  ],
  DBS_Q: ['DBS_Q_1', 'DBS_Q_2', 'DBS_Q_3', 'DBS_Q_4', 'DBS_Q_5', 'DBS_Q_6'],
  DBS_R: ['DBS_R_1', 'DBS_R_2', 'DBS_R_3', 'DBS_R_4'],
  DBS_S: ['DBS_S_1', 'DBS_S_2', 'DBS_S_3', 'DBS_S_4']
}

export default detailedBusinessSectors
